export default {
  title: {
    en: '10 year anniversary sale - take up to 60% off [shop now]',
  },
}
